import { render, staticRenderFns } from "./DeviceTableUser.vue?vue&type=template&id=82dea7da&scoped=true&"
import script from "./DeviceTableUser.vue?vue&type=script&lang=js&"
export * from "./DeviceTableUser.vue?vue&type=script&lang=js&"
import style0 from "./DeviceTableUser.vue?vue&type=style&index=0&id=82dea7da&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82dea7da",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pro-tekt/protekt_webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('82dea7da')) {
      api.createRecord('82dea7da', component.options)
    } else {
      api.reload('82dea7da', component.options)
    }
    module.hot.accept("./DeviceTableUser.vue?vue&type=template&id=82dea7da&scoped=true&", function () {
      api.rerender('82dea7da', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/stats/DeviceTableUser.vue"
export default component.exports